<template>
  <el-row class="" >
    <el-col :xs="24" :sm="24" :md="8" :lg="8">
      <el-form-item label="项目类型">
        <el-select v-model="formData.service_type" placeholder="项目类型" class="select-option" @change="serviceChange">
          <el-option
            v-for="(item,index) in serviceData"
            :key="index"
            :label="item.recruit_type_text"
            :value="item.recruit_type">
          </el-option>
        </el-select>
      </el-form-item>
    </el-col>
    <el-col :xs="24" :sm="24" :md="8" :lg="8">
      <el-form-item label="日本会社">
        <el-select v-model="formData.company_id" placeholder="日本会社" class="select-option" :disabled="company_name" @change="companyChange">
          <el-option
            v-for="(item,index) in companyData"
            :key="index"
            :label="item.company_name"
            :value="item.company_id">
          </el-option>
        </el-select>
      </el-form-item>
    </el-col>
    <el-col :xs="24" :sm="24" :md="8" :lg="8">
      <el-form-item label="职位名称">
        <el-select v-model="formData.posision_id" placeholder="职位名称" class="select-option" :disabled="recruit_name">
          <el-option
            v-for="(item,index) in recruitData"
            :key="index"
            :label="item.recruit_name"
            :value="item.recruit_id">
          </el-option>
        </el-select>
      </el-form-item>
    </el-col>
  </el-row>
</template>
<script>

export default {
  name: 'JmLinkage',
  data() {
    return {
      company_name: true,
      recruit_name: true,
      serviceData: [],
      companyData: [],
      recruitData: [],
    };
  },
  props: {
    // 默认搜索项为空
    options: {
      type: Array,
      default: function() {
        return [];
      }
    },
    recruit: {
      type: Array,
      default: function() {
        return [];
      }
    },
    // 默认不过滤字段（搜索表单展示搜索项时过滤）
    needFilter: {
      type: Boolean, default: false
    },
    formData: {
      type: Object,
      default: function() {
        return {};
      }
    },
    option_service: {
      type: Object,
      default: function() {
        return {};
      }
    },
    // 表单值
    optionData: {
      type: Object,
      default: function() {
        return {};
      }
    },

  },
  methods: {
    uniqueArray(array) {
      let arr = array;
      for (let i = 0; i < arr.length; i++) {
        for (let j = i + 1; j < arr.length;) {
          if (arr[i].recruit_type === arr[j].recruit_type) {
            arr.splice(j, 1);
          } else j++;
        }
      }
      return arr;
    },
    serviceChange() {
      this.formData.company_id = '';
      this.formData.company_id_text = '';
      this.formData.posision_id = '';
      this.formData.posision_id_text = '';
    },
    companyChange() {
      this.formData.posision_id = '';
      this.formData.posision_id_text = '';
    },

  },
  created() {
    let arr = this.recruit.slice(0);
    this.serviceData = this.uniqueArray(arr);
    this.recruit.forEach((item) => {
      this.companyData.push({
        company_name: item.company_name,
        company_id: item.company_id,
      });
      this.recruitData.push({
        recruit_name: item.recruit_name,
        recruit_id: item.recruit_id,
      });
    });
  },
  mounted() {

  },
  watch: {
    formData: {
      handler(val) {
        this.companyData = [];
        this.recruitData = [];
        this.company_name = false;
        this.recruit_name = false;
        this.recruit.forEach((item) => {
          if (item.recruit_type === val.service_type) {
            val.service_type_text = item.recruit_type_text;
            this.companyData.push({
              company_name: item.company_name,
              company_id: item.company_id,
            });
          }
          if (item.company_id === val.company_id) {
            val.company_id_text = item.company_name;
            this.recruitData.push({
              recruit_name: item.recruit_name,
              recruit_id: item.recruit_id,
            });
          }
          if (item.recruit_id === val.posision_id) {
            val.posision_id_text = item.recruit_name;
          }
        });
      },
      deep: true
    }
  }
};
</script>
<style lang='less' scoped>
.select-option{
  margin-left: 6px;
  margin-right: 16px;
}
</style>
